import { Form as FormikForm } from 'formik';
import styled from 'styled-components';

export const Scaffold = styled.section`
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.device.mobile} {
    height: 100%;
    background-color: ${({ theme }) => theme.rule.background};
  }
`;

export const Body = styled.section`
  display: flex;
  flex-direction: column;
  max-width: 1300px;
`;

interface FormBodyProps {
  padding?: boolean;
}

export const FormBody = styled.div<FormBodyProps>`
  @media ${({ theme }) => theme.device.desktop} {
    padding-bottom: ${({ padding }) => (padding ? '106px' : '0')};
  }
`;

export const Form = styled(FormikForm)`
  flex: 1;
  margin-top: auto;

  &:first-child {
    padding-top: 0;
  }
`;

export const Division = styled.hr`
  height: 1px;
  border: none;
  background-color: ${({ theme }) => theme.rule.division};
`;
